import { render, staticRenderFns } from "./installersCapacities.vue?vue&type=template&id=a6661a98&"
import script from "./installersCapacities.vue?vue&type=script&lang=js&"
export * from "./installersCapacities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports